import React, { useEffect, useState } from "react";
import { Form, Offcanvas } from "react-bootstrap";
import { FaCheck, FaXmark } from "react-icons/fa6";
import { cdiscServices } from "../../../../../Services/CDISC/cdiscServices";

const VariableFilter = ({
  Show,
  Hide,
  Title,
  variableList,
  setVariableList,
  studyId,
  getCDISCVariablesList,
  setFilter,
  filter
}) => {
  const [domain, setDomain] = useState("");
  const [domainList, setDomainList] = useState([]);
  const [mathod, setMathod] = useState("");
  const [mathodList, setMathodList] = useState([]);
  const [comment, setComment] = useState("");
  const [commentList, setCommentList] = useState([]);
  const [core, setCore] = useState("");
  const [coreList, setCoreList] = useState([]);
  const [role, setRole] = useState("");
  const [roleList, setRoleList] = useState([]);
  const [list, setList] = useState("");
  const [codeList, setCodeList] = useState([]);
  const [type, setType] = useState("");
  const [dataTypeList, setDataTypeList] = useState([]);
  const [mandatory, setMandatory] = useState("");
  const [origin, setOrigin] = useState("");
  const [originList, setOriginList] = useState([]);

  const filterCDISCVariablesList = async () => {
    let userData = {};
    userData.studyId = studyId;
    userData.domainId = domain;
    userData.mathodId = mathod;
    userData.commentId = comment;
    userData.codeList = list;
    userData.type = type;
    userData.role = role;
    userData.core = core;
    userData.mandatory = mandatory;
    userData.origin = origin;
    let data = await cdiscServices.filterCDISCVariablesList(userData);
    setVariableList(data?.data || []);
    setFilter(true)
    Hide();
  };

  const clearFilterData = () => {
    setDomain("");
    setMathod("");
    setComment("");
    setList("");
    setType("");
    setCore("");
    setRole("");
    setMandatory("");
    setOrigin("");
    Hide();
    getCDISCVariablesList();
    setFilter(false)
  };

  // useEffect(() => {
  //   if (!filter) {
  //     clearFilterData()
  //   }
  // }, [filter])

  useEffect(() => {
    setDomainList(
      Array.from(
        new Map(
          variableList?.map((item) => [
            item.domain + "_" + item.domainId,
            { domain: item.domain, domainId: item.domainId },
          ])
        ).values()
      )
    );
    setMathodList(
      Array.from(
        new Map(
          variableList
            ?.filter((item) => item.mathodId !== "")
            .map((item) => [
              item.mathod + "_" + item.mathodId,
              { mathod: item.mathod, mathodId: item.mathodId },
            ])
        ).values()
      )
    );
    setCommentList(
      Array.from(
        new Map(
          variableList
            ?.map((item) => [
              item.comment + "_" + item.commentId,
              { comment: item.comment, commentId: item.commentId },
            ])
            .filter((item) => item?.commentId !== "") || []
        ).values()
      )
    );
    setCodeList(
      Array.from(
        new Map(
          variableList
            ?.filter((item) => item.codeListData !== "" && item.codeList !== "")
            .map((item) => [
              item.codeListData + "_" + item.codeList,
              { codeListData: item.codeListData, codeList: item.codeList },
            ]) || []
        ).values()
      )
    );
    setCoreList(
      Array.from(
        new Set(
          variableList?.map((item) => item.core).filter((core) => core) || []
        )
      )
    );
    setRoleList(
      Array.from(
        new Set(
          variableList?.map((item) => item.role).filter((role) => role) || []
        )
      )
    );
    setDataTypeList(
      Array.from(
        new Set(
          variableList?.map((item) => item.type).filter((type) => type) || []
        )
      )
    );
    setOriginList(
      Array.from(
        new Set(
          variableList?.map((item) => item.origin).filter((origin) => origin) ||
          []
        )
      )
    );
  }, [variableList]);

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header>
          <Offcanvas.Title>{Title} </Offcanvas.Title>
          <div onClick={Hide} className="close_modal" title="Close">
            X
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <div
            className="pt-2 px-3 overflow-auto"
            style={{ height: "calc(100vh - 84px)" }}
          >
            <Form.Group className="mb-2">
              <Form.Label className="mb-1 fw-bold">Domain Id</Form.Label>
              <Form.Select onChange={(e) => setDomain(e.target.value)}>
                <option value="">Select Domain Id</option>
                {domainList?.map((item, index) => (
                  <option
                    selected={item.domainId === domain}
                    key={index}
                    value={item.domainId}
                  >
                    {item.domain}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label className="mb-1 fw-bold">Data Type</Form.Label>
              <Form.Select onChange={(e) => setType(e.target.value)}>
                <option value="">Select Data Type</option>
                {dataTypeList?.map((item, index) => (
                  <option selected={item === type} key={index} value={item}>
                    {item}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label className="mb-1 fw-bold">Role</Form.Label>
              <Form.Select onChange={(e) => setRole(e.target.value)}>
                <option value="">Select Role</option>
                {roleList?.map((item, index) => (
                  <option selected={item === role} key={index} value={item}>
                    {item}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label className="mb-1 fw-bold">Core</Form.Label>
              <Form.Select onChange={(e) => setCore(e.target.value)}>
                <option value="">Select Core</option>
                {coreList?.map((item, index) => (
                  <option selected={item === core} key={index} value={item}>
                    {item}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label className="mb-1 fw-bold">Origin</Form.Label>
              <Form.Select onChange={(e) => setOrigin(e.target.value)}>
                <option value="">Select Origin</option>
                {originList?.map((item, index) => (
                  <option selected={item === origin} key={index} value={item}>
                    {item}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            {mathodList?.length > 0 && (
              <Form.Group className="mb-2">
                <Form.Label className="mb-1 fw-bold">Mathod</Form.Label>
                <Form.Select onChange={(e) => setMathod(e.target.value)}>
                  <option value="">Select Mathod</option>
                  {mathodList?.map((item, index) => (
                    !item.mathodId ? "" :
                      <option
                        selected={item.mathodId === mathod}
                        key={index}
                        value={item.mathodId}
                      >
                        {item.mathod}
                      </option>
                  ))}
                </Form.Select>
              </Form.Group>
            )}
            {commentList?.length > 0 && (
              <Form.Group className="mb-2">
                <Form.Label className="mb-1 fw-bold">Comment</Form.Label>
                <Form.Select onChange={(e) => setComment(e.target.value)}>
                  <option value="">Select Comment</option>
                  {commentList?.map((item, index) => (
                    !item.commentId ? "" :
                      <option
                        selected={item.commentId === comment}
                        key={index}
                        value={item.commentId}
                      >
                        {item.comment}
                      </option>
                  ))}
                </Form.Select>
              </Form.Group>
            )}
            {codeList?.length > 0 && (
              <Form.Group className="mb-2">
                <Form.Label className="mb-1 fw-bold">Code List</Form.Label>
                <Form.Select onChange={(e) => setList(e.target.value)}>
                  <option value="">Select Code List</option>
                  {codeList?.map((item, index) => (
                    !item.codeList ? "" :
                      <option
                        selected={item.codeList === list}
                        key={index}
                        value={item.codeList}
                      >
                        {item.codeListData}
                      </option>
                  ))}
                </Form.Select>
              </Form.Group>
            )}
          </div>
          <div className="justify-content-end py-2 px-3 shadow-sm bg-light w-100 hstack gap-2">
            {filter &&
              <button
                className="py-1 px-3 border   text-white bg-danger me-2 fontSize12"
                onClick={() => clearFilterData()}
              >
                <FaXmark /> Clear
              </button>
            }
            <button
              className="updateProfile"
              onClick={() => filterCDISCVariablesList()}
            >
              <FaCheck /> Apply
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default VariableFilter;
